export default {
  properties: {
    rendered: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    this.rendered = true;
  },
};
